import { Restore as RestoreIcon, AttachFile as AttachFileIcon, Visibility as VisibilityIcon, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { Table, TableBody, TableCell, TableRow, TableHead, TableSortLabel, Checkbox, Tooltip, Box } from '@mui/material';
import { NoRecordFound } from '../../../../shared_elements';
import moment from 'moment';
import { dateMonthYearDateFormat, dateMonthYearFormatTime } from '../../../../constants';
import { PermissionWrapper } from '../../../../wrappers';
import { trackActivity } from '../../../../utils/mixpanel';
import UploadingIcon from '../../../../shared_elements/components/UploadingIcon';
import { getApiResponse } from '../../../../utils/fileUpload';
import NumericLabel from 'react-pretty-numbers';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AuditPopover from '../../../../shared_elements/components/popover';

function NonCashTxnList({ txnslug, uploadFileProgressData, viewFileStatus, item, onOpenAttachments, onView, viewRevisonHistory, onEditFn, onDeleteTxn, bulk, toggleBulkOps, createSortHandler, sortInfo, cashTxnSorting, sdcData }) {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Security Deposit NonCash Txn Listing`, page_type: page_type, })
    }

    const transactions = item?.transactions?.length > 0 ? (cashTxnSorting[item?.slug]?.list?.length ? cashTxnSorting[item?.slug]?.list : item?.transactions) || [] : [];

    const Header = ({ toggleBulkOps, item, bulk, slug, createSortHandler }) => {
        const tableSorting = (key, name, slug) => {
            const groupSort = sortInfo[slug] || {};
            return (
                <TableSortLabel
                    active={groupSort.sort_by === key}
                    direction={groupSort.sort_by === key ? groupSort.sort : 'asc'}
                    onClick={() => { createSortHandler(key, slug); handleItemClicked(`Table Sorting: ${name}`) }}
                >
                    {name}
                </TableSortLabel>
            )
        }
        return (
            <TableHead>
                <TableRow>
                    <TableCell className="table-actions-header">
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "security_deposit", operationType: ['D'] }}>
                            <Checkbox color='primary' size='small' onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item, 2)} checked={slug === bulk?.ids[0]?.security_deposit_slug && item?.length === bulk?.ids?.length} />
                        </PermissionWrapper>
                        Action(s)
                    </TableCell>
                    <TableCell sx={{ minWidth: '145px' }}>{tableSorting("reference_number", "Reference No.", slug)}</TableCell>
                    <TableCell sx={{ minWidth: '145px' }}>{tableSorting("issue_date", "Issue Date", slug)}</TableCell>
                    <TableCell sx={{ minWidth: '180px' }}>{tableSorting("contractual_amount", "Contractual Amount", slug)}</TableCell>
                    {sdcData?.base_currency && <TableCell sx={{ minWidth: '145px' }}>{tableSorting("base_amount", "Base Amount", slug)}</TableCell>} 
                    <TableCell sx={{ minWidth: '100px' }}>{tableSorting("validity_start_date", "Start Date ", slug)}</TableCell>
                    <TableCell sx={{ minWidth: '100px' }}>{tableSorting("validity_end_date", "End Date", slug)}</TableCell>
                    <TableCell sx={{ minWidth: '180px' }}>{tableSorting("status", "Status", slug)}</TableCell>
                </TableRow>
            </TableHead>
        )
    }
    return (
        <>
            <div style={{ maxHeight: `${window.innerHeight - 278}px`, overflow: 'auto' }}>
                <Table className='mui-table-format' stickyHeader sx={{ "& .MuiTableCell-root": { py: 0.8, padding: '5px 2px' } }}>
                    <Header bulk={bulk} item={item?.transactions} toggleBulkOps={toggleBulkOps} sortInfo={sortInfo} createSortHandler={createSortHandler} slug={item?.slug} />
                    <TableBody>
                        {transactions?.length > 0 && transactions?.map((cash, index) => {
                           const uploadedFileData = getApiResponse("security_deposit", cash?.slug);
                           return (
                            <>
                                <TableRow>
                                    <TableCell className="table-actions-list">
                                        <Box className="table-icon-container">
                                           <Checkbox style={{ verticalAlign: 'super' }} color="primary" size='small' checked={bulk?.ids.find(items => items?.id === cash?.id) ? true : false} onChange={(e) => toggleBulkOps(e.target.checked, 'single', cash, 2)} />
                                            <AuditPopover item={item}> <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} /> </AuditPopover>
                                            <Tooltip title="Revision History"><RestoreIcon className='revision-history' onClick={() => { viewRevisonHistory(cash); handleItemClicked('RevisionHistoryIcon') }} sx={{ cursor: 'pointer' }} fontSize='small' color='primary' /></Tooltip>
                                           <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "security_deposit", operationType: ['R'] }}>
                                                <Tooltip title="View"><VisibilityIcon sx={{ cursor: 'pointer' }} onClick={() => { onView(cash); handleItemClicked('ViewIcon') }} fontSize='small' color='primary' /></Tooltip>
                                           </PermissionWrapper>
                                           <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "security_deposit", operationType: ['U'] }}>
                                                <Tooltip title="Edit"><EditIcon sx={{ cursor: 'pointer' }} onClick={() => { onEditFn(cash); handleItemClicked('EditIcon') }} fontSize='small' color='primary' /></Tooltip>
                                           </PermissionWrapper>
                                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "security_deposit", operationType: ['D'] }}>
                                                <Tooltip title="Delete"><DeleteIcon sx={{ cursor: 'pointer' }} onClick={() => { onDeleteTxn(cash); handleItemClicked('DeleteIcon') }} fontSize='small' color='error' /></Tooltip>
                                           </PermissionWrapper>
                                           <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "security_deposit", operationType: ['R'] }}>
                                            {
                                                cash?.attachments?.length > 0 && (
                                                    <Tooltip title="Attached File(s)">
                                                        <Box className="attachment-container">
                                                            <AttachFileIcon fontSize="small" color="primary" onClick={() => { onOpenAttachments(cash, 2); handleItemClicked('AttachmentsIcon') }} sx={{ cursor: "pointer" }} />
                                                            <Box className="attachment-count">({cash.attachments.length})</Box>
                                                        </Box>
                                                    </Tooltip>
                                                )
                                            }
                                        </PermissionWrapper>
                                         { (txnslug === cash?.slug) && <UploadingIcon viewFileStatus={() => viewFileStatus(uploadedFileData)} /> }
                                        </Box>
                                    </TableCell>
                                    <TableCell>{cash?.reference_number || '--'}</TableCell>
                                    <TableCell>{cash?.issue_date ? moment(cash.issue_date).format(dateMonthYearDateFormat) : '--'} </TableCell>
                                    {/* <TableCell>{cash?.contractual_amount ? sdcData?.contractual_currency?.code + " " + sdcData?.contractual_currency?.symbol + "" + cash?.contractual_amount : '--'}</TableCell> */}
                                    <TableCell>
                                        {cash?.contractual_amount ? (
                                            <NumericLabel
                                                params={{
                                                    locales: 'en-GB',
                                                    currency: true,
                                                    precision: 2,
                                                    currencyIndicator: cash?.currency?.code || sdcData?.contractual_currency?.code || '',
                                                    commafy: true,
                                                    justification: "L",
                                                }}
                                            >
                                            {Number(cash.contractual_amount)}
                                            </NumericLabel>
                                           ) : (
                                               "--"
                                           )}
                                    </TableCell>
                                    {/* <TableCell>{cash?.base_amount ? sdcData?.base_currency?.code + " " + sdcData?.base_currency?.symbol + "" + cash?.base_amount : '--'}</TableCell> */}
                                    {sdcData?.base_currency && 
                                    <TableCell>
                                        {cash?.base_amount ? (
                                            <NumericLabel
                                                params={{
                                                    locales: 'en-GB',
                                                    currency: true,
                                                    precision: 2,
                                                    currencyIndicator: cash?.currency?.code || sdcData?.base_currency?.code || '',
                                                    commafy: true,
                                                    justification: "L",
                                                }}
                                            >
                                            {Number(cash.base_amount)}
                                            </NumericLabel>
                                            ) : (
                                            "--"
                                            )}
                                    </TableCell>}
                                    <TableCell>{cash?.validity_start_date ? moment(cash.validity_start_date).format(dateMonthYearDateFormat) : '--'} </TableCell>
                                    <TableCell>{cash?.validity_end_date ? moment(cash.validity_end_date).format(dateMonthYearDateFormat) : '--'} </TableCell>
                                    <TableCell>{cash?.status?.label || '--'}</TableCell>
                                </TableRow>
                            </>
                            )
                        })}
                    </TableBody>
                </Table>
            </div>
            {transactions?.length === 0 && <NoRecordFound />}
        </>
    )
}

export default NonCashTxnList